var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4A545E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.475 4.275h13.05m-9.45 0v-.9a1.8 1.8 0 0 1 1.8-1.8h2.25a1.8 1.8 0 0 1 1.8 1.8v.9m-.9 3.6v4.95m-4.05-4.95v4.95m-3.6-8.55h11.25l-.58 10.45a1.8 1.8 0 0 1-1.798 1.7H5.753a1.8 1.8 0 0 1-1.797-1.7z"
  })));
};
export default SvgTrash;